<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ $t('message.sts') }}</h3>
            </div>
            <div class="layout__controls">
                <form :action="action" method="POST" enctype="multipart/form-data">
                    <input type="hidden" name="_token" id="csrf-token" :value="token">
                    <div class="form-inline">
                        <div class="form-field">
                            <input type="file" name="file" id="file">
                        </div>
                        <div class="form-field">
                            <button class="btn-success" type="submit"><i class="fa fa-file-excel-o"></i><span>{{ $t('message.importar') }}</span></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="card">
                            <div class="card__title">
                                <h5>{{ $t('message.filtros') }}</h5>
                            </div>
                            <div class="card__content">
                                <div class="row">
                                    <div v-show="!form.general" class="col-xs-12 col-md-4">
                                        <div class="form-field select2">
                                            <div class="select2-field">
                                                <v-select @input="inputLinea" :options="lineas" label="nombre" id="filtroLinea" v-model="selectedLinea"></v-select>
                                                <label for="filtroLinea">{{ $t('message.linea') }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="!form.general" class="col-xs-12 col-md-4">
                                        <div class="form-field">
                                            <label for="soloMaquinas">
                                                <input @change="$refs.listaSts.loadRows()" type="radio" id="soloMaquinas" value="M" v-model="form.tipo"> <span>{{ $t('message.maquina') }}</span>
                                            </label>
                                            <label for="soloCajas">
                                                <input @change="$refs.listaSts.loadRows()" type="radio" id="soloCajas" value="C" v-model="form.tipo"> <span>{{ $t('message.caja') }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-4">
                                        <div class="form-field">
                                            <label for="generalFiltro">
                                                <input @change="changeGeneral" type="checkbox" id="generalFiltro" v-model="form.general"> <span>{{ $t('message.busquedaGeneral') }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <k-table 
                            exportable
                            :params="form"
                            @editar="editar"
                            @eliminar="eliminar"
                            @crear="crear"
                            :columns="columns"
                            :path="path"
                            ref="listaSts"
                            :deleteButton="deleteButton && permiteEliminar" 
                            :createButton="permiteCrear" 
                            :editButton="editButton && permiteEditar"></k-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        token : {
            type : String,
            required : true
        },
        action : {
            type : String,
            required : true
        },
        permiteCrear : {
            type : Boolean,
            required : false, 
            default : true
        },
        permiteEditar : {
            type : Boolean, 
            required : false, 
            default : true
        },
        permiteEliminar : {
            type : Boolean, 
            required : false, 
            default : true
        },
        exportable : {
            type : Boolean,
            required : false,
            default : false
        },
        tituloFormulario : {
            type : String,
            required : false,
            default : 'C'
        },
        descripcionFormulario : {
            type : String,
            required : false,
            default : 'Lista de códigos STS'
        },
        title : {
            type : String,
            required : false,
            default : 'STS'
        },
        createButton : {
            required : false,
            default : true,
            type : Boolean
        },
        editButton : {
            required : false,
            default : true,
            type : Boolean
        },
        deleteButton : {
            required : false,
            default : true,
            type : Boolean
        },
        path : {
            type : String,
            required : false, 
            default : url + '/sts'
        },
        lineaText : {
            type : String,
            required : false,
            default : 'Línea'
        },
        codigoText : {
            type : String,
            required : false,
            default : 'Código'
        },
        descripcionText : {
            type : String,
            required : false,
            default : 'Descripción'
        },
        sizeText : {
            type : String,
            required : false,
            default : 'Size'
        },
        notaText : {
            type : String,
            required : false,
            default : 'Nota'
        },
        horasHombreText : {
            type : String,
            required : false,
            default : 'Horas hombre'
        },
        creacionText : {
            type : String,
            required : false,
            default : 'Creación'
        },
        modificacionText : {
            type : String,
            required : false,
            default : 'Modificación'
        },
        tipoText : {
            type : String,
            required : false,
            default : 'Tipo'
        },
        columns : {
            type : Array,
            required : false,
            default : function () {
                return [
                    {
                        display : this.$t('message.codigo'),
                        value : 'codigo'
                    },
                    {
                        display : this.$t('message.tipo'),
                        value : 'descripcion_tipo'
                    },
                    {
                        display : this.$t('message.siglas'),
                        value : 'siglas'
                    },
                    {
                        display : this.$t('message.linea'),
                        value : 'descripcion_linea'
                    },
                    {
                        display : this.$t('message.descripcion'),
                        value : 'descripcion'
                    },
                    {
                        display : this.$t('message.tipo_unidad'),
                        value : 'codigo_tipo_unidad'
                    },
                    {
                        display : this.$t('message.horas_hombre'),
                        value : 'horas_hombre'
                    },
                    {
                        display : this.$t('message.partes'),
                        value : 'numero_materiales'
                    },
                    {
                        display : this.$t('message.piezas'),
                        value : 'maximo_piezas'
                    },
                    {
                        display : this.$t('message.valor'),
                        value : 'valor'
                    },
                    {
                        display : this.$t('message.tiposModelo'),
                        value : 'tipos_modelo'
                    },
                    {
                        display : this.$t('message.creador'),
                        value : 'nombre_creador'
                    },
                    {
                        display : this.$t('message.modificador'),
                        value : 'nombre_modificador'
                    },
                    {
                        display : this.$t('message.creacion'),
                        value : 'created_at'
                    },
                    {
                        display : this.$t('message.modificacion'),
                        value : 'updated_at'
                    }
                ];
            }
        }
    },
    data : function () {
        return {
            selectedIndex : -1,
            selectedItem : null,
            tipoGuardado : 'N',
            url : url,
            lineas : [],
            modos : [],
            materiales : [],
            url : url,
            form : {
                linea_id : '',
                tipo : '',
                general : true
            },
            selectedLinea : null,
        }
    },
    methods : {
        inputLinea : function () {
            if (this.selectedLinea !== null) 
                this.form.linea_id = this.selectedLinea.code;
            else 
                this.form.linea_id = '';
            this.$refs.listaSts.loadRows();
        },
        changeGeneral : function () {
            if (this.form.general) {
                this.selectedLinea = null;
                this.form.tipo = '';
                this.inputLinea();
            }
        },
        crear : function () {
            window.open(this.url + '/sts/create', '_blank');
        },
        editar : function (row) {
            window.open(this.url + '/sts/' + row.id + '/edit', '_blank');
        },
        eliminar : function (row) {
            this.selectedIndex = this.$refs.listaSts.rows.indexOf(row);
            this.selectedItem = row;
            let enabled = row.estado === 'A';
            let that = this;
            swal({
                title: (this.$t('message.deseas') + ' ' + (enabled?this.$t('message.desactivar'):this.$t('message.activar')) + ' ' + this.$t('message.esteRegistro') + ' ? '),
                text: this.$t('message.requiereConfirmacion'),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: that.$t('message.confirmar'),
                cancelButtonText : that.$t('message.cancelar')
                }).then((result) => {
                    if (result.value) {
                        axios.post(that.url + '/sts/' + row.id, {
                            _method : 'DELETE'
                        }).then(function (response) {
                            swal(that.$t('message.elRegistro') + ' ' + (enabled?that.$t('message.desactivado'):that.$t('message.activado')) + '.', that.$t('message.aviso'), 'success');
                            that.$refs.listaSts.rows.splice(that.selectedIndex, 1);
                            that.selectedIndex = -1;
                            that.selectedItem = null;
                        });
                    }
                    else {
                        that.selectedIndex = -1;
                        that.selectedItem = null;
                    }
                }).catch(function (error) {
                    if (error !== null && error !== undefined) {
                        let response = error.response;
                        if (response !== undefined && response !== null) {
                            swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                        }
                    }
                });
        },
        cancelar : function () {
            this.selectedIndex = -1;
            this.selectedItem = null;
            this.$modal.hide('sts');
        },
        saved : function(row) {
            if (this.selectedIndex === -1)
                this.$refs.listaSts.rows.unshift(row);
            else 
                this.$refs.listaSts.rows.splice(this.selectedIndex, 1, row);
            this.selectedIndex = -1;
            this.selectedItem = null;
            this.$modal.hide('sts');
        },
        cargarDatosFormulario : function () {
            let that = this;
            axios.get(that.url + '/sts/formulario').then(function (response) {
                that.lineas = response.data.lineas;
                that.modos = response.data.modos;
                that.materiales = response.data.materiales;
            });
        }
    },
    mounted : function () {
        this.cargarDatosFormulario();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/sts/ListaSts.vue